"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.securityMocks = void 0;

var _msw = require("msw");

var getSecuritySettings = _msw.rest.get('/api/v1/security/settings', function (req, res, ctx) {
  return res(ctx.json({
    data: {
      forceSSO: {
        enabled: false
      },
      dashboardAccess: {
        enabled: false
      },
      revenueImpactDashboardAccess: {
        enabled: false
      },
      revenueImpactDashboardCreatedPipeline: {
        enabled: false,
        numberOfDaysBeforeOpportunityIsCreated: 10
      },
      allowedDomains: []
    }
  }));
});

var securityMocks = [getSecuritySettings];
exports.securityMocks = securityMocks;